import { mapper } from '../../tools/mapping/mapper';
import { MaterielAdduction } from '../../domain/Adduction-air/materiel-adduction';
import { MaterielAdductionEntity } from '../entity';
import type { AppDB } from '../db';

export class MaterielAdductionRepository {
    constructor(private readonly database: AppDB) {}


    async getMaterielAdductionEntityByCode(code: string) {
        return await this.database.materielAdduction.where('Code').equals(code).first(async mle => {
            return mle;
        });
    }

    async getMaterielAdductionById(id: number) {
        return await this.database.materielAdduction.where('Id').equals(id).first(async mle => {
            const ml = mapper.map(mle, MaterielAdductionEntity, MaterielAdduction);
            return ml;
        });
    }

    async attachMaterielAdduction(measure: MaterielAdduction, adductionId: number) {
        let materielId: number;
        const mae = mapper.map(measure, MaterielAdduction, MaterielAdductionEntity);

        const me = await this.database.getMesureAdductionEntityById(adductionId);
        materielId = await this.database.materielAdduction.add(mae);
        await this.database.measureAdduction.update(adductionId, {
            MaterielAdductionIds: me?.MaterielAdductionIds ? [...me.MaterielAdductionIds, materielId] : [materielId]
        });
    }

    async clearMaterielAdductionById(ids: number[]) {
        await this.database.materielAdduction.where('Id').anyOf(ids).toArray(async phe => {
            for (let i = 0; i < phe.length; i++) {
                if (phe && phe[i].Id !== undefined) {
                    await this.database.materielAdduction.where('Id').equals(phe[i].Id!).delete();
                }
            }
        })
    }
}
